<template>
  <div class="dashborad-embajador">
    <titulo-seccion titulo="DASHBOARD"> </titulo-seccion>
    <div class="w-100 p-5">
      <div class="row w-100">

        <div class="col-12 col-sm-12 col-md-6 col-lg-6" data-app>
          <div class="row" style="margin: 0 0 10px">Fecha inicial</div>
          <input-fecha idioma="es-MX" v-model="fechaInicio" :fechaMaxima="new Date().toISOString()"></input-fecha>
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
          <div class="row" style="margin: 0 0 10px">Fecha final</div>
          <input-fecha idioma="es-MX" v-model="fechaFinal" :fechaMaxima="new Date().toISOString()"></input-fecha>
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-6" v-if="tipoUsuario == 6 ||
          tipoUsuario == 7 ||
          tipoUsuario == 8 ||
          tipoUsuario == 9 ||
          tipoUsuario == 10
          ">
          <div class="row" style="margin: 0 0 10px">Sucursal</div>
          <DropDown :placeholder="sucursales.length > 0 ?  'Selecciona una sucursal' : 'Cargando sucursales ... '" :arreglo="sucursales" llave="sucursalId" valor="sucursalId"
            texto="nombre" v-model="sucursal" :disabled="switchValue"></DropDown>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6" v-if="tipoUsuario == 6 ||
          tipoUsuario == 7 ||
          tipoUsuario == 8 ||
          tipoUsuario == 9 ||
          tipoUsuario == 10
          ">
          <div class="row" style="margin: 0 0 10px">Gerencia</div>
          <DropDown :placeholder="!sucursal ? 'Selecciona una sucursal primero' :  isloadingCatalogGerente ? 'Cargando gerencias ...' : 'Seleccione una gerencia'" :arreglo="gerencias" llave="gerenciaId" valor="gerenciaId"
            texto="nombre" v-model="gerencia" :disabled="switchValue"></DropDown>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6" v-if="tipoUsuario == 6 ||
          tipoUsuario == 7 ||
          tipoUsuario == 8 ||
          tipoUsuario == 9 ||
          tipoUsuario == 10
          ">
          <div class="row" style="margin: 0 0 10px">Embajador</div>
          <DropDown 
          :placeholder="!gerencia ? 'Selecciona una gerencia primero' :  isLoadingCatalogoEmbajadores ? 'Cargando gerencias ...' : 'Seleccione un embajador'"
          :arreglo="embajadoresGerente" llave="masterId" valor="masterId"
            texto="nombre" v-model="embajadores" :disabled="switchValue"></DropDown>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
          <div class="row" style="margin: 0 0 10px">Gráfica</div>


          <DropDown placeholder="Selecciona una gráfica" :arreglo="graficasItems" llave="valor" valor="valor"
            texto="nombre" v-model="opcionGrafica" :requerido="false"></DropDown>
        </div>
        <div class="d-flex justify-content-end align-items-end w-100 gap-5">
          <div class="">
            <v-switch v-model="switchValue" label-position="left" inset :label="`Mostrar todo`" @change="onSwitchChange"
              v-if="tipoUsuario == 6 ||
                tipoUsuario == 7 ||
                tipoUsuario == 8 ||
                tipoUsuario == 9 ||
                tipoUsuario == 10
                "></v-switch>
          </div>
          <div class="">
            <button class="boton-primario mb-3 p-2" style="width: 300px;" v-on:click="borrarFiltros">
              Borrar filtros
            </button>
          </div>
        </div>

      </div>
    </div>
    <div class="p-5 py-0">
      <GraficaReporteGeneal v-if="mostrarGrafica[0]" :masterId="masterId != null ? masterId : ''"
        :embajadorId="embajadorId" :sucursalId="sucursalId" :fechaInicio="fechaInicio" :fechaFinal="fechaFinal"
        :mostrarTodo="mostrarTodo" :gerenciaId="gerenciaId"/>

      <GraficaReporteActividades v-if="mostrarGrafica[1]" :masterId="masterId != null ? masterId : ''"
        :embajadorId="embajadorId" :sucursalId="sucursalId" :fechaInicio="fechaInicio" :fechaFinal="fechaFinal"
        :mostrarTodo="mostrarTodo" :gerenciaId="gerenciaId" />

      <GraficaReporteConcentradoFinal v-if="mostrarGrafica[2]" :masterId="masterId != null ? masterId : ''"
        :embajadorId="embajadorId" :sucursalId="sucursalId" :fechaInicio="fechaInicio" :fechaFinal="fechaFinal"
        :mostrarTodo="mostrarTodo" :gerenciaId="gerenciaId" />

      <GraficaReporteVentas v-if="mostrarGrafica[3]" :masterId="masterId != null ? masterId : ''"
        :embajadorId="embajadorId" :sucursalId="sucursalId" :fechaInicio="fechaInicio" :fechaFinal="fechaFinal"
        :soloGerente="soloGerente" :gerenciaId="gerenciaId" :mostrarTodo="mostrarTodo" />

    </div>
    <div class="p5" v-if="!fechaInicio || !fechaFinal">
      <div class="d-flex justify-content-center flex-column align-items-center">
        <img src="https://hircasageneral.blob.core.windows.net/embajadores-manager/img/images/GraphicsEmpty.svg">
        <p style="font-size: 24px; width: 50%; text-align: center; color: #98A2B3;">
          Selecciona<b> fecha de inicio y fin </b><br> para comenzar a recopilar información.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import DropDown from "../../Prospecto/components/DropDown.vue";
import InputFecha from "../components/InputFecha.vue";
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import GraficaReporteGeneal from "../../Prospecto/components/GraficaReporteGeneral.vue";
import GraficaReporteActividades from "../../Prospecto/components/GraficaReporteActividades.vue";
import GraficaReporteConcentradoFinal from "../../Prospecto/components/GraficaReporteConcentradoFinal.vue";
import GraficaReporteVentas from "../../Prospecto/components/GraficaReporteVentas.vue";

const listarSucursalesGerente = "/api/Master/Master/ListarSucursalesGerente";
const listarEmbajadoresGerente =
  "/api/Master/Master/ListarEmbajadoresPorJerarquia";
const listarGerenciasGerente = "/api/Master/Master/ListarGerenciasPorJerarquia";

export default {
  name: "Dashboard2",
  components: {
    DropDown,
    InputFecha,
    TituloSeccion,
    GraficaReporteGeneal,
    GraficaReporteActividades,
    GraficaReporteConcentradoFinal,
    GraficaReporteVentas,
  },
  data() {
    return {
      switchValue: false,
      checkbox: true,
      NombreUsuario: "",
      ApellidoUsuario: "",
      masterId: this.$store.getters.masterId,
      embajadorId: null,
      sucursalId: null,
      gerenciaId: null,
      fechaInicio: "",
      fechaFinal: "",
      mostrarTodo: false,
      soloGerente: true,
      graficas: [
        { nombre: "Gráfica de Reporte General", valor: 1 },
        { nombre: "Gráfica de Reporte de Actividades por Personal", valor: 2 },
        {
          nombre: "Gráfica de Reporte Concentrado Final de Operaciones",
          valor: 3,
        },
        { nombre: "Gráfica de Reporte de Ventas", valor: 4 },
      ],
      graficasEmbajador: [
        { nombre: "Gráfica de Reporte General", valor: 1 },
        { nombre: "Gráfica de Reporte de Actividades por Personal", valor: 2 },

      ],
      opcionGrafica: null,
      mostrarGrafica: [true, false, false, false],
      sucursales: [],
      sucursal: null,
      gerencias: [],
      gerencia: null,
      embajadoresGerente: [],
      embajadores: null,
      tipoUsuario: null,
      esGerente: null,
      nombreEmbajador: [],
      fechaMaxima: null,
      isloadingCatalogGerente: false,
      isLoadingCatalogoEmbajadores: false
    };
  },
  watch: {
    opcionGrafica: async function (value) {
      this.mostrarGrafica[0] = false;
      this.mostrarGrafica[1] = false;
      this.mostrarGrafica[2] = false;
      this.mostrarGrafica[3] = false;
      this.opcionGrafica = value;
      this.mostrarGrafica[value - 1] = true;
    },
    embajadores(value) {
      this.embajadorId = value;
    },
    sucursal(value) {
      this.sucursalId = value;
      this.embajadorId = null;
      this.gerenciaId = null;
      this.embajadores = null;
      this.gerencia = null;
      this.embajadoresGerente = [];
      this.gerencias = [];
      this.listaGerencias(this.gerente(this.tipoUsuario), this.sucursalId);
    },
    gerencia(value) {
      this.gerenciaId = value;
      this.embajadorId = null;
      this.embajadores = null;
      this.embajadoresGerente = [];
      this.listaEmbajadores(
        this.sucursalId,
        this.gerenciaId
      );
    },
    fechaInicio: {
      handler: function (value, oldValue) {
        if (value > this.fechaFinal) {
          this.AlertaEmbajadores(
            "La fecha inicial no puede ser mayor a la fecha final",
            true
          );
          this.fechaInicio = value;
          this.resetFechaIncio(oldValue);
        } else {
          this.fechaInicio = value;
        }
      },
    },
    fechaFinal: {
      handler: function (value, oldValue) {
        if (value < this.fechaInicio) {
          this.AlertaEmbajadores(
            "La fecha inicial no puede ser mayor a la fecha final",
            true
          );
          this.fechaFinal = value;
          this.resetFechaFinal(oldValue);
        } else {
          this.fechaFinal = value;
        }
      },
    },
  },
  created() {
    this.formatoFecha();
  },
  mounted() {
    this.tipoUsuario = this.$store.getters.tipoUsuario;
    this.NombreUsuario = sessionStorage.getItem("nombreUsuario");
    this.ApellidoUsuario = sessionStorage.getItem("apellidoUsuario");

    this.gerente(this.tipoUsuario);
    this.listaSucursales(this.masterId);
    this.listaGerencias(this.gerente(this.tipoUsuario), this.sucursalId);
  },
  computed: {
    NombreCompletoUsuario() {
      return (
        this.NombreUsuario.toUpperCase() +
        " " +
        this.ApellidoUsuario.toUpperCase()
      );
    },
    graficasItems() {
      if (this.tipoUsuario == 6 || this.tipoUsuario == 7 || this.tipoUsuario == 8 || this.tipoUsuario == 9 || this.tipoUsuario == 10) {
        return this.graficas
      }
      else return this.graficasEmbajador
    }
  },
  methods: {

    onSwitchChange() {
      this.embajadores = null
      this.sucursal = null
      this.gerencia = null
      this.mostrarTodoFuncion()
    },
    gerente(tipoUsuario) {
      return tipoUsuario === 6 || tipoUsuario === 9
        ? (this.esGerente = true)
        : (this.esGerente = false);
    },
    async listaGerencias(esGerente, proyectoId) {
      const params = {
        params: { proyectoId },
      };
      try {
        this.isloadingCatalogGerente = true;
        const resp = await axios.get(listarGerenciasGerente, params);
        const gerencias = resp.data.data;
        gerencias.map((gerencia) => {
          this.gerencias.push({
            nombre: gerencia.nombre,
            gerenciaId: gerencia.gerenciaId,
          });
        });
      } catch (error) {
        console.log(error);
      }finally{
        this.isloadingCatalogGerente = false;
      }
    },
    async listaSucursales(masterId) {
      const params = {
        params: { masterId },
      };
      try {
        const resp = await axios.get(listarSucursalesGerente, params);
        const sucursales = resp.data.data;
        sucursales.map((sucursal) => {
          this.sucursales.push({
            nombre: sucursal.nombre,
            sucursalId: sucursal.sucursalId,
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async listaEmbajadores(sucursalId, gerenciaId) {
      this.isLoadingCatalogoEmbajadores = true;
      const params = {
        params: { proyectoId: sucursalId, gerenciaId: gerenciaId },
      };
      try {
        const resp = await axios.get(listarEmbajadoresGerente, params);
        const nombresEmbajadores = resp.data.data;
        if (nombresEmbajadores.length > 0) {
          nombresEmbajadores.map((embajador) => {
            this.embajadoresGerente.push({
              nombre: embajador.nombres + " " + embajador.apellidoPaterno,
              masterId: embajador.masterId,
            });
          });
        } else {
          this.embajadoresGerente = [
            {
              nombre: this.NombreCompletoUsuario,
              masterId: this.masterId,
            },
          ];
        }
      } catch (error) {
        console.log(error);
      }finally{
        this.isLoadingCatalogoEmbajadores = false 
      }
    },
    formatoFecha() {
      const fechaActual = new Date();
      const year = fechaActual.getFullYear();
      const month = fechaActual.getMonth() + 1;
      const day = fechaActual.getDate();
      const fechaCompleta =
        year +
        "-" +
        (month < 10 ? `0${month}` : month) +
        "-" +
        (day < 10 ? `0${day}` : day);
      this.fechaInicio = fechaCompleta;
      this.fechaFinal = fechaCompleta;
    },
    borrarFiltros() {
      this.embajadorId = null;
      this.sucursalId = null;
      this.gerenciaId = null;
      this.gerencia = null;
      this.sucursal = null;
      this.embajadores = null;
      this.mostrarTodo = false;
      this.soloGerente = true;
      this.switchValue = false
      this.formatoFecha();
    },
    resetFechaIncio(value) {
      setTimeout(() => {
        this.fechaInicio = value;
      }, 10);
    },
    resetFechaFinal(value) {
      setTimeout(() => {
        this.fechaFinal = value;
      }, 10);
    },
    mostrarTodoFuncion() {
      // this.embajadorId = null;
      // this.sucursalId = null;
      // this.gerenciaId = null;
      // this.gerencia = null;
      // this.sucursal = null;
      // this.embajadores = null;
      this.soloGerente = !this.soloGerente;
      this.mostrarTodo = !this.mostrarTodo;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

.boton-primario-outlined {
  border-radius: 0px !important;
  border: 1px solid #b8725a !important;
  box-shadow: none !important;
  color: #b8725a !important;
  font-family: $poppins !important;
}

.boton-primario {
  border-radius: 0px !important;
  background-color: #b8725a !important;
  box-shadow: none !important;
  color: #ffffff !important;
  font-family: $poppins !important;
}

.boton-primario:hover {
  color: #ffffff !important;
  background-color: #a56651 !important;
}

.boton-primario:focus {
  box-shadow: none !important;
}
</style>
